export default {
    startsWith: "始まる",
    contains: "含む",
    notContains: "含まない",
    endsWith: "終わる",
    equals: "等しい",
    notEquals: "等しくない",
    noFilter: "フィルターなし",
    lt: "未満",
    lte: "以下",
    gt: "大きい",
    gte: "以上",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    clear: "クリア",
    apply: "適用",
    matchAll: "一致する",
    matchAny: "いずれか",
    addRule: "ルール追加",
    removeRule: "ルール削除",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    dayNames: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
    dayNamesShort: ["日", "月", "火", "水", "木", "金", "土"],
    dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
    monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    today: "今日",
    weekHeader: "週",
    firstDayOfWeek: 0,
    dateFormat: "yy/mm/dd",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    emptyMessage: "No available options",
}
